<template lang="pug">
  div(v-if="achievementOne")
    portal(to="pageTitle")
      span Редактировать достижение

    v-container
      Settings(
        :languages="languages"
        :locale="locale"

        @languageChanged="onLanguageChanged"
      )

      .mt-10

      Content(
        :name="name"
        :nameDescription="nameDescription"
        :header="header"
        :description="description"
        :image="image"
        @nameChanged="onNameChanged"
        @nameDescriptionChanged="onNameDescriptionChanged"
        @headerChanged="onHeaderChanged"
        @descriptionChanged="onDescriptionChanged"
        @imageChanged="onImageChanged"
      )

      .mt-10

      Controls(
        hasDelete
        @save="onSave"
        @delete="onDelete"
      )

</template>

<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import GetGQL from '../../graphql/private/Achievement/Get.gql'
import UpdateGQL from '../../graphql/private/Achievement/Update.gql'
import RemoveGQL from '../../graphql/private/Achievement/Remove.gql'

export default {
  name: 'achievements__id',
  components: {
    Settings,
    Content,
    Controls,
  },
  mixins: [Mixin, notify],
  data() {
    return {
      routeId: this.$route.params.id,
    }
  },

  apollo: {
    achievementOne: {
      query: GetGQL,
      variables() {
        return {
          filter: {
            id: this.routeId,
            locale: this.locale,
          },
        }
      },
    },
  },
  methods: {
    async onSave() {
      try {
        await this.$apollo.mutate({
          mutation: UpdateGQL,
          variables: {
            achievement: {
              id: this.routeId,
              active: true,
              image: this.imageFile,
              locale: this.locale,
              description: this.description,
              header: this.header,
              name: this.name,
              nameDescription: this.nameDescription,
            },
          },
        })

        await this.$apollo.queries.achievementOne.refetch()
        this.imageFile = null

        this.notify({
          text: 'Достижение обновлено!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },

    async onDelete() {
      try {
        await this.$apollo.mutate({
          mutation: RemoveGQL,
          variables: {
            id: this.routeId,
          },
        })

        this.notify({
          text: 'Достижение удалено!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
      await this.$router.push({
        name: 'achievements__list',
      })
    },
  },

  watch: {
    achievementOne(achievement) {
      if (!achievement) {
        this.$router.push({
          name: 'achievements__list',
        })
      }
      const pst = {
        ...achievement,
      }
      for (const field in pst) {
        this[field] = pst[field]
      }
      this.files = this.attachments
    },
  },
}
</script>
